<template>
  <div>
    <div class="row">
      <div class="form-group col-md-3 col-md-push-3">
        <label class="fs">Start Date</label>
        <date-picker
          v-model="start.date"
          format="yyyy-MM-dd"
          input-class="form-control bg-white"
        />
      </div>
      <div class="form-group col-md-3">
        <label class="fs">End Date</label>
        <date-picker
          v-model="to.date"
          format="yyyy-MM-dd"
          input-class="form-control bg-white"
        />
      </div>
    </div>
    <table
      ref="tbbids"
      class="table table-striped"
    >
      <thead>
        <tr>
          <th>#</th>
          <th>AMOUNT</th>
          <th>TRANSACTION NUMBER</th>
          <th>REFERENCE</th>
          <th>DEAL DATE</th>
          <th>ACCOUNT</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(d,i) in payments"
          :key="i"
        >
          <td>{{ i + 1 }}</td>
          <td>{{ d.amount_paid }}</td>
          <td>{{ d.transaction_number }}</td>
          <td>{{ d.reference }}</td>
          <td>{{ d.deal_date }}</td>
          <td>{{ d.account }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
import DatePicker from 'vuejs-datepicker';
import moment from 'moment/src/moment';
import $ from 'jquery';

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      dt: "",
      start: {
        date: moment().add('-1', 'week').toDate()
      },
      to: {
        date: moment().toDate()
      }
    }
  },
  computed: {
    payments() {
      return this.$store.getters.getPayments;
    },
    period() {
      return [this.start.date, this.to.date].join();
    }
  },
  watch: {
    period() {
      if (this.start.date && this.to.date) {
        this.fetch();
      }
    },
    payments() {
      if (this.dt) this.dt.destroy();
      this.$nextTick(() => {
        this.dt = $(this.$refs.tbbids).DataTable({
          dom: 'Bfrtip',
          buttons: [{extend: 'csvHtml5', text: 'Excel'}]
        });
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.dt = $(this.$refs.tbbids).DataTable({
        dom: 'Bfrtip',
        buttons: [{extend: 'csvHtml5', text: 'Excel'}]
      });
    });
    this.fetch();
  },
  methods: {
    fetch() {
      this.$store.dispatch('fetchPayments', {start: this.start.date, end: this.to.date});
    },
  }
}
</script>
